import React from "react";
import {StockStatusBase} from "./StockStatusBase";

export const StockStatusRO = () => {
    const translations = {
        lastProduct: 'Ultimul produs din stoc',
        stockStatuses: {
            'In stoc': 'În stoc',
            'Stoc limitat': 'Stoc limitat',
            'La comanda': 'La comandă',
            'La furnizor': 'La furnizor',
            'In stoc furnizor': 'În stoc furnizor',
            'Stoc extern cu livrare rapida': 'Stoc extern cu livrare rapidă',
            'Rezervat': 'Rezervat'
        }
    };

    const getStockValue = (status: string) => {
        switch (status) {
            case 'În stoc':
                return 'Avem mai mult de 5 bucăți în stoc.';
            case 'Stoc limitat':
                return 'Avem mai puțin de 5 bucăți în stoc.';
            case 'Ultimul produs din stoc':
                return 'Produsul se află în stocul fizic al Magaziei.';
            case 'La comandă':
            case 'La furnizor':
            case 'În stoc furnizor':
            case 'Stoc extern cu livrare rapidă':
                return 'Produsul nu este disponibil în stocul Magaziei, dar este posibil să fie în depozitul furnizorului. ' +
                    'Dacă înregistrezi o comandă pentru acest produs, unul dintre consultanții noștri de vânzări va verifica ' +
                    'disponibilitatea produsului la furnizor și te va contacta în cel mai scurt timp posibil.';
            case 'Rezervat':
                return 'Produsul se află în stocul fizic al Magaziei, dar apare rezervat pentru un client. ' +
                    'Dacă sunteți interesat, vă rugăm să ne contactați să verificăm dacă rezervarea pe acest produs mai este de actualitate sau nu.';
            default:
                return '';
        }
    }

    return <StockStatusBase getStockValue={getStockValue} translations={translations}/>;
}
